import { useQuery } from '@tanstack/react-query'

import { getMycleContentDetail } from '@/entities/content'

import { CAR_STORY_QUERY_KEYS } from '../../lib/queryKeys'

const useMycleContentDetailQuery = (contentId: number) =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.DETAIL.detail(contentId),
    queryFn: () => getMycleContentDetail(contentId),
    enabled: Number.isFinite(contentId) && contentId > 0,
    throwOnError: false,
    // 유저 개인화 데이터(liked)가 응답에 포함되어 다른 유저로 전환 시 이전 캐시가 노출될 수 있음 → 캐시 미사용
    gcTime: 0,
    // prefetch 초기 데이터를 마운트 시 재요청 안 하도록 fresh 유지 (gcTime:0이라 언마운트 시 캐시 폐기)
    staleTime: Infinity,
  })

export default useMycleContentDetailQuery
